import React from 'react';
import { Tooltip } from 'react-tippy';
import { useTooltipOptions } from '../../hooks/use-tooltip-options';
import WarningIcon from '../../assets/icons/warning.svg';
import './app-mode-indicator.scss';
/**
 * An indicator for the top toolbar that displays a warning when you are in preview/dev mode.
 *
 * @param appMode the current app mode
 */
const AppModeIndicator = ({ appMode }) => {
    const tipOptions = useTooltipOptions();
    const kPreviewTooltipHtml = React.createElement("div", null,
        React.createElement("p", null,
            React.createElement("strong", null, "You are in preview mode."),
            React.createElement("br", null),
            "You can explore and try things out, but any changes will not be permanently saved."),
        React.createElement("p", null,
            "To save your work or assign this activity, please sign in or create an account at ",
            React.createElement("a", { href: "https://learn.concord.org" }, "learn.concord.org"),
            "."));
    if (appMode !== "dev")
        return null;
    return (React.createElement(Tooltip, Object.assign({}, tipOptions, { interactive: true, html: kPreviewTooltipHtml }),
        React.createElement("div", { className: "mode" },
            React.createElement(WarningIcon, null),
            "Preview Mode")));
};
export default AppModeIndicator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLW1vZGUtaW5kaWNhdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NsdWUvY29tcG9uZW50cy9hcHAtbW9kZS1pbmRpY2F0b3IudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUMxQixPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBR3RDLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLGlDQUFpQyxDQUFDO0FBRXBFLE9BQU8sV0FBVyxNQUFNLGdDQUFnQyxDQUFDO0FBRXpELE9BQU8sMkJBQTJCLENBQUM7QUFNbkM7Ozs7R0FJRztBQUNILE1BQU0sZ0JBQWdCLEdBQW9DLENBQUMsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFO0lBRXhFLE1BQU0sVUFBVSxHQUFHLGlCQUFpQixFQUFFLENBQUM7SUFFdkMsTUFBTSxtQkFBbUIsR0FDekI7UUFDRTtZQUNFLCtEQUF5QztZQUFBLCtCQUFLO2lHQUU1QztRQUNKOztZQUFxRiwyQkFBRyxJQUFJLEVBQUMsMkJBQTJCLHdCQUFzQjtnQkFBSyxDQUMvSSxDQUFDO0lBRVAsSUFBSSxPQUFPLEtBQUssS0FBSztRQUFFLE9BQU8sSUFBSSxDQUFDO0lBRW5DLE9BQU8sQ0FDTCxvQkFBQyxPQUFPLG9CQUFLLFVBQVUsSUFBRSxXQUFXLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxtQkFBbUI7UUFDbkUsNkJBQUssU0FBUyxFQUFDLE1BQU07WUFDbkIsb0JBQUMsV0FBVyxPQUFHOzJCQUVYLENBQ0UsQ0FDWCxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxnQkFBZ0IsQ0FBQyJ9